import { customAlphabet } from 'nanoid';

const prefixes: Record<string, unknown> = {};

type GenerateIdOptions = {
  length?: number;
  separator?: string;
};

export function generateId(
  prefixOrOptions?: keyof typeof prefixes | GenerateIdOptions,
  inputOptions: GenerateIdOptions = {},
) {
  const finalOptions =
    typeof prefixOrOptions === 'object' ? prefixOrOptions : inputOptions;

  const prefix =
    typeof prefixOrOptions === 'object' ? undefined : prefixOrOptions;

  const { length = 12, separator = '_' } = finalOptions;
  const id = customAlphabet(
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
    length,
  )();

  return prefix && prefix in prefixes
    ? `${prefixes[prefix]}${separator}${id}`
    : id;
}
